"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";
interface Props {
  label?: string;
  title?: string;
  content?: string;
}
const Accordion = ({
  label = "",
  title = "",
  content = ""
}: Props) => {
  const [isActive, setIsActive] = useState(false);
  return <motion.div className="accordion-item" data-sentry-element="unknown" data-sentry-component="Accordion" data-sentry-source-file="Accordion.tsx">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div className="accordion-header">
          <div className="accordion-header-text">
            {label !== "" && <label>{label}</label>}
            <h4>{title}</h4>
          </div>
          <div className="w-10 h-10">
            <motion.svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none" animate={{
            rotate: isActive ? -180 : 0
          }} transition={{
            duration: 0.3
          }} data-sentry-element="unknown" data-sentry-source-file="Accordion.tsx">
              <path d="M13.3333 17.1666L20 23.8333L26.6666 17.1666" stroke="#002726" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="Accordion.tsx" />
            </motion.svg>
          </div>
        </div>

        {isActive && <div className="accordion-content">{content}</div>}
      </div>
    </motion.div>;
};
export default Accordion;